export default {
    cloudwatch: {
        que: "Observabilidad: recoge métricas y registros de tus servicios, dibuja paneles, y dispara alarmas y acciones cuando algo se sale de lo normal.",
        patron: "lineal",
        nodos: [["Recursos y aplicaciones", "servidor"], ["Métricas y logs", "grafico"], ["Alarma", "campana"], ["Acción (SNS, Auto Scaling)", "funcion"]],
        pasos: ["Los servicios publican métricas (CPU, errores) y tus aplicaciones envían logs.", "CloudWatch evalúa las métricas contra los umbrales que definiste.", "Si se supera el umbral, la alarma avisa o ejecuta una acción, como escalar."],
        objetos: {
            "Métricas": ["Series de números en el tiempo (CPU, peticiones, latencia).", 1],
            "Alarmas": ["Vigilan una métrica y cambian de estado cuando cruza un límite.", 2],
            "Dashboards": ["Paneles con gráficos de métricas y logs.", 1],
            "Log Groups": ["Agrupan los registros de una aplicación, con retención configurable.", 1],
            "Log Streams": ["Secuencia de eventos de una fuente concreta dentro de un grupo.", 1],
            "Insights": ["Consultas sobre los logs para buscar y analizar eventos.", 1],
            "Synthetics": ["Scripts que prueban tu sitio o API cada cierto tiempo desde fuera.", 0],
        },
    },
    cloudtrail: {
        que: "Bitácora de auditoría: registra quién hizo qué, cuándo y desde dónde en tu cuenta de AWS (cada llamada a la API).",
        patron: "lineal",
        nodos: [["Usuario / servicio", "usuario"], ["Llamada a la API", "nube"], ["CloudTrail", "archivo"], ["Bucket S3 de auditoría", "carpeta"]],
        pasos: ["Alguien hace algo en AWS: crea, cambia o borra un recurso.", "El servicio registra la acción como un evento.", "CloudTrail guarda el evento en un archivo de bitácora que queda en S3 para auditoría y alertas."],
        objetos: {
            "Trails": ["Configuración que entrega los eventos a S3 y CloudWatch Logs de forma continua.", 2],
            "Event History": ["Los últimos 90 días de eventos de administración, consultables sin configurar nada.", 2],
            "Event Data Stores": ["Almacén para consultar eventos con SQL durante años.", 2],
        },
    },
    cloudformation: {
        que: "Infraestructura como código: describes tus recursos en una plantilla y CloudFormation los crea, actualiza y elimina en el orden correcto.",
        patron: "lineal",
        nodos: [["Plantilla (YAML / JSON)", "archivo"], ["Stack", "engranaje"], ["Recursos AWS", "nube"]],
        pasos: ["Escribes la plantilla con todo lo que necesitas: redes, servidores, bases.", "CloudFormation crea el stack resolviendo dependencias y, si algo falla, revierte; al cambiar la plantilla calcula las diferencias."],
        objetos: {
            "Stacks": ["Conjunto de recursos creado desde una plantilla, que se gestiona como una unidad.", 1],
            "StackSets": ["Despliega la misma plantilla en varias cuentas y regiones.", 1],
            "Plantillas": ["El documento que describe la infraestructura.", 0],
            "Change Sets": ["Vista previa de los cambios que se harán antes de aplicarlos.", 1],
        },
    },
    config: {
        que: "Registra cómo está configurado cada recurso a lo largo del tiempo y comprueba si cumple tus reglas (por ejemplo «ningún bucket público»).",
        patron: "lineal",
        nodos: [["Recursos AWS", "nube"], ["AWS Config", "lupa"], ["Regla", "candado"], ["Conforme / No conforme", "campana"]],
        pasos: ["Config registra la configuración de cada recurso y sus cambios.", "Evalúa cada cambio contra las reglas.", "Marca los recursos como conformes o no conformes y puede corregirlos automáticamente."],
        objetos: {
            "Reglas": ["Condiciones que debe cumplir cada recurso (de AWS o propias).", 2],
            "Recursos": ["Inventario con la historia de configuración de cada recurso.", 0],
            "Conformance Packs": ["Conjunto de reglas empaquetado para un estándar de cumplimiento.", 2],
            "Aggregators": ["Reúnen datos de varias cuentas y regiones en una sola vista.", 1],
        },
    },
    organizations: {
        que: "Agrupa varias cuentas de AWS bajo una organización, con facturación única y reglas de permisos que bajan en cascada.",
        patron: "abanico",
        nodos: [["Cuenta de administración", "usuario"], ["Organización (raíz)", "red"], ["OU Producción", "carpeta"], ["OU Desarrollo", "carpeta"], ["OU Seguridad", "carpeta"]],
        pasos: ["La cuenta de administración crea la organización y la estructura de unidades.", "Las cuentas se organizan en OU; las SCP definen el máximo de permisos permitido para cada OU.", "Cada cuenta hereda esos límites y la facturación se consolida."],
        objetos: {
            "Cuentas": ["Cada cuenta de AWS miembro, con sus recursos aislados.", 2],
            "Unidades organizativas": ["Carpetas para agrupar cuentas y aplicar políticas en bloque.", 2],
            "SCPs": ["Políticas que limitan lo que cualquier usuario de una cuenta puede hacer, incluso el administrador.", 1],
        },
    },
    controltower: {
        que: "Configura y gobierna un entorno multicuenta seguro con buenas prácticas ya aplicadas (landing zone), con controles preventivos y de detección.",
        patron: "lineal",
        nodos: [["Control Tower", "engranaje"], ["Landing Zone", "red"], ["Controles (guardrails)", "escudo"], ["Cuentas nuevas", "nube"]],
        pasos: ["Control Tower prepara la landing zone: estructura de cuentas, registros y red base.", "Activa los controles que impiden o detectan acciones peligrosas.", "Las cuentas nuevas se crean ya cumpliendo esa base."],
        objetos: {
            "Landing Zone": ["Entorno multicuenta base con cuentas de registro y auditoría.", 1],
            "Controles": ["Reglas preventivas (SCP) o de detección (Config) que se aplican a las OU.", 2],
            "Cuentas": ["Cuentas creadas desde el Account Factory con la base de seguridad.", 3],
        },
    },
    ssm: {
        que: "Administra tus servidores a escala: ejecutar comandos, entrar sin SSH, aplicar parches, guardar parámetros y automatizar tareas operativas.",
        patron: "lineal",
        nodos: [["Administrador", "usuario"], ["Systems Manager", "engranaje"], ["Agente SSM", "servidor"], ["Instancias", "servidor"]],
        pasos: ["El administrador elige una acción (comando, sesión, parche) en la consola o por API.", "Systems Manager la envía a los agentes instalados en cada instancia, sin abrir puertos ni usar SSH.", "Las instancias ejecutan y devuelven el resultado y su estado."],
        objetos: {
            "Parameter Store": ["Guarda configuraciones y secretos simples, con jerarquía y versiones.", 1],
            "Run Command": ["Ejecuta un comando en muchas instancias a la vez.", 1],
            "Session Manager": ["Abre una terminal en la instancia sin SSH ni claves, con registro de la sesión.", 2],
            "Patch Manager": ["Aplica parches del sistema operativo en una ventana de mantenimiento.", 3],
            "Inventario": ["Recopila qué software y configuración tiene cada instancia.", 2],
            "Automation": ["Flujos de runbooks para tareas operativas repetibles.", 1],
            "Documentos": ["Definiciones (SSM Documents) de lo que hace un comando o automatización.", 1],
        },
    },
    trustedadvisor: {
        que: "Revisa tu cuenta y recomienda mejoras en costo, rendimiento, seguridad, tolerancia a fallas y límites de servicio.",
        patron: "lineal",
        nodos: [["Tu cuenta", "nube"], ["Trusted Advisor", "lupa"], ["Recomendaciones", "campana"]],
        pasos: ["Trusted Advisor analiza la configuración y el uso de tus recursos.", "Compara con buenas prácticas y te muestra qué corregir: recursos sin uso, puertos abiertos, límites cercanos."],
        objetos: {
            "Chequeos": ["Verificaciones por categoría con su estado (ok, advertencia, error).", 1],
            "Recomendaciones": ["Acciones sugeridas con el ahorro o la mejora esperada.", 2],
        },
    },
    servicecatalog: {
        que: "Catálogo de productos aprobados de TI: los equipos lanzan por su cuenta infraestructura ya validada por el área de seguridad.",
        patron: "lineal",
        nodos: [["Administrador", "usuario"], ["Portafolio / Producto", "carpeta"], ["Usuario final", "usuario"], ["Recursos desplegados", "nube"]],
        pasos: ["El administrador publica productos (plantillas aprobadas) en un portafolio.", "Entrega acceso a los equipos que corresponda.", "El usuario lanza el producto con un clic y se crea la infraestructura según lo aprobado."],
        objetos: {
            "Portafolios": ["Colección de productos con las personas que pueden usarlos.", 1],
            "Productos": ["Plantilla de infraestructura aprobada, con versiones.", 1],
        },
    },
    licensemgr: {
        que: "Controla el uso de licencias de software (Microsoft, Oracle, SAP) con reglas de conteo y límites para no excederse.",
        patron: "lineal",
        nodos: [["Servidor que usa software", "servidor"], ["License Manager", "clave"], ["Licencia (límite)", "archivo"]],
        pasos: ["Defines la licencia y cuántas unidades tienes (núcleos, sockets, instancias).", "Al lanzar un recurso se descuenta una unidad; si se acabaron, el lanzamiento se bloquea o se avisa."],
        objetos: {
            "Licencias": ["Las licencias que posees y sus reglas de uso.", 2],
            "Configuraciones": ["Reglas que conectan una licencia con las instancias (tipo de conteo y límite).", 1],
        },
    },
    healthdash: {
        que: "Informa del estado de los servicios de AWS y de eventos que afectan específicamente a tus recursos (mantenciones, fallas).",
        patron: "lineal",
        nodos: [["AWS", "nube"], ["Health Dashboard", "campana"], ["Tu equipo", "usuario"]],
        pasos: ["AWS publica un evento: una falla regional o una mantención programada.", "El panel muestra qué recursos tuyos están afectados y puede notificarte por correo o EventBridge."],
        objetos: {
            "Eventos": ["Incidentes, mantenciones y avisos de cambios.", 1],
            "Entidades afectadas": ["Los recursos de tu cuenta que impacta cada evento.", 1],
        },
    },
    xray: {
        que: "Rastrea una petición a través de todos los servicios que atraviesa, para encontrar dónde se demora o falla en una arquitectura distribuida.",
        patron: "lineal",
        nodos: [["Cliente", "usuario"], ["API", "nube"], ["Servicio A", "funcion"], ["Base de datos", "datos"]],
        pasos: ["La petición entra con un identificador de traza.", "Cada servicio por el que pasa registra su tramo (segmento) con tiempos.", "X-Ray reúne los segmentos en una traza y dibuja el mapa de servicios, mostrando el eslabón lento o con errores."],
        objetos: {
            "Trazas": ["La historia completa de una petición con todos sus segmentos.", 1],
            "Service Map": ["Mapa de los servicios y sus conexiones con latencia y errores.", 1],
            "Grupos": ["Filtros que reúnen trazas por criterio para ver su estadística.", 1],
        },
    },
};
